import { memo } from 'react'
import { useSelector } from 'react-redux'
import { selectQuickTradeQuoteSignature } from '../../selectors/security'
import { parseQuickTradeQuoteSignature } from '../../util/quickTradeQuote'

type QuickTradeConditionalLastPriceProps = {
    securityKey: string
    /** Basket spread modal passes zeroed OHLC — no live LTP from snapshot. */
    useZeroQuote?: boolean
    children: (values: { lastPrice: number; lastVolume: number }) => React.ReactNode
}

const QuickTradeConditionalLastPrice: React.FC<QuickTradeConditionalLastPriceProps> = ({
    securityKey,
    useZeroQuote = false,
    children,
}) => {
    if (useZeroQuote) {
        return <>{children({ lastPrice: 0, lastVolume: 0 })}</>
    }
    const signature = useSelector(selectQuickTradeQuoteSignature(securityKey))
    const quote = parseQuickTradeQuoteSignature(signature)
    return <>{children({ lastPrice: quote.snapLtp, lastVolume: quote.volume })}</>
}

export default memo(QuickTradeConditionalLastPrice)
